import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { getCompanyName } from 'owa-attachment-data';
import {
    AttachmentFullViewState,
    AttachmentMenuAction,
    getSaveToCloudEstimatedCompleteTimeInMS,
    isSaveToCloudApplicable,
    saveToCloud,
    setActionCompletePercent,
    startFakeProgressIndicator,
    stopFakeProgressIndicator,
} from 'owa-attachment-full-data';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { PreviewContext } from 'owa-attachment-select-actions';
import { MailboxType } from 'owa-client-ids';
import loc, { format } from 'owa-localize';
import { SaveOneFileToGroupFilesText } from 'owa-locstrings/lib/strings/saveonefiletogroupfilestext.locstring.json';
import { SaveOneFileToOneDriveConsumerText } from 'owa-locstrings/lib/strings/saveonefiletoonedriveconsumertext.locstring.json';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import ItemId from 'owa-service/lib/contract/ItemId';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import isMenuActionSupported from '../../utils/isMenuActionSupported';
import getSenderFromItemId from '../../utils/getSenderFromItemId';
import { SaveOneFileToOneDriveText } from './saveToCloudContextMenuItemBuilder.locstring.json';

export default function saveToCloudContextMenuItemBuilder(
    attachment: AttachmentFullViewState,
    providerType?: string,
    targetWindow?: Window,
    sxsId?: string,
    isConsumerBoolean?: boolean,
    attachmentOriginalUrl?: string,
    permissionLevel?: AttachmentPermissionLevel,
    previewContext?: PreviewContext,
    parentItemId?: ItemId
): IContextualMenuItem {
    const attachmentModel = getAttachment(attachment.attachmentId);
    const isGroup = attachment.attachmentId.mailboxInfo?.type === MailboxType.GroupMailbox;
    const isConsumerGroup = isConsumer() && isGroup;

    if (
        !attachmentModel ||
        !isMenuActionSupported(AttachmentMenuAction.SaveToCloud, attachment) ||
        !isSaveToCloudApplicable(attachment) ||
        isConsumerGroup
    ) {
        return null;
    }

    return {
        name: getSaveToCloudContextMenuName(isGroup),
        key: 'Save to OneDrive',
        onClick: () => {
            startFakeProgressIndicator(
                getSaveToCloudEstimatedCompleteTimeInMS(attachment.attachmentId),
                0.1,
                (completePercent: number) => {
                    setActionCompletePercent(attachment, completePercent);
                },
                attachment.attachmentId
            );
            saveToCloud(
                attachment,
                (succeeded: boolean) => {
                    stopFakeProgressIndicator(attachment.attachmentId, succeeded);
                },
                'ContextMenu',
                parentItemId,
                getSenderFromItemId(parentItemId?.Id)
            );
        },
    };
}

function getSaveToCloudContextMenuName(isGroup: boolean): string {
    if (isGroup) {
        return loc(SaveOneFileToGroupFilesText);
    }

    return isConsumer()
        ? loc(SaveOneFileToOneDriveConsumerText)
        : format(loc(SaveOneFileToOneDriveText), getCompanyName());
}
